import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-table-normal",
  "use": "icon-table-normal-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-table-normal\"><path d=\"M85.333333 170.666667h853.333334v170.666666H85.333333zM85.333333 384h170.666667v469.333333H85.333333z\" p-id=\"1948\" /><path d=\"M298.666667 384h640v128H298.666667z\" opacity=\".6\" p-id=\"1949\" /><path d=\"M298.666667 554.666667h640v128H298.666667z\" p-id=\"1950\" /><path d=\"M298.666667 725.333333h640v128H298.666667z\" opacity=\".6\" p-id=\"1951\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol